import { Routes } from "@angular/router";
import { AuthenticateGuard } from "@kalmarenergi/data-access/iam/guards";
import { StaticRoutes } from "@kalmarenergi/features";
import { routes as iamRoutes } from "@kalmarenergi/iam";

export const routes: Routes = [
  {
    path: "auth",
    children: iamRoutes,
  },
  {
    path: "",
    loadChildren: () =>
      import("./modules/layout/layout.routes").then((m) => m.routes),
    canActivate: [AuthenticateGuard],
  },
  ...StaticRoutes,
];
